import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateBuilder from './EstimateBuilder';
import resetModalState from '../actions/resetModalState';
import loadEstimate from '../actions/loadEstimate';
import getDCSignature from '../actions/getDCSignature';

const mapStateToProps = ({ estimateBuilder: { uiState } }) => {
  const { selectedEstimate } = uiState;

  return {
    selectedDesignId: selectedEstimate,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ resetModalState, loadEstimate, getDCSignature }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EstimateBuilder);
